import palette from '../palette';

export default {
  gutterBottom: {
    marginBottom: 8,
    backgroundColor: palette.primary.main,
  },
};
